import { render, staticRenderFns } from "./BaseHistoryRestore.vue?vue&type=template&id=198a2f8a&scoped=true"
import script from "./BaseHistoryRestore.vue?vue&type=script&lang=js"
export * from "./BaseHistoryRestore.vue?vue&type=script&lang=js"
import style0 from "./BaseHistoryRestore.vue?vue&type=style&index=0&id=198a2f8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198a2f8a",
  null
  
)

export default component.exports